import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ShopSuccessPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      pollStatus(sessionId);
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  const pollStatus = async (sessionId, attempts = 0) => {
    if (attempts >= 5) { setStatus('error'); return; }
    try {
      const { data } = await axios.get(`${API}/api/shop/order/${sessionId}`, { withCredentials: true });
      if (data.payment_status === 'paid') { setStatus('success'); return; }
      if (data.status === 'expired') { setStatus('error'); return; }
      setTimeout(() => pollStatus(sessionId, attempts + 1), 2000);
    } catch { setStatus('error'); }
  };

  return (
    <div className="min-h-screen pt-28 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && (
          <div>
            <Loader2 size={64} className="mx-auto text-[#C5A059] mb-8 animate-spin" />
            <h1 className="font-serif text-3xl text-[#F5F5F0] mb-4">Processing Order</h1>
            <p className="text-[#A3A3A3]">Please wait while we confirm your purchase...</p>
          </div>
        )}
        {status === 'success' && (
          <div>
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#C5A059]/20 flex items-center justify-center">
              <CheckCircle size={48} className="text-[#C5A059]" />
            </div>
            <h1 className="font-serif text-4xl text-[#F5F5F0] mb-4">Order Confirmed!</h1>
            <p className="text-[#A3A3A3] mb-8">Thank you for your purchase. You'll receive a confirmation email shortly.</p>
            <Link to="/shop" className="inline-flex items-center gap-3 bg-[#C5A059] text-[#0A0A0A] px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#E0BE77] transition-colors" data-testid="back-to-shop">
              Continue Shopping <ArrowRight size={16} />
            </Link>
          </div>
        )}
        {status === 'error' && (
          <div>
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#D84B79]/20 flex items-center justify-center">
              <XCircle size={48} className="text-[#D84B79]" />
            </div>
            <h1 className="font-serif text-4xl text-[#F5F5F0] mb-4">Order Failed</h1>
            <p className="text-[#A3A3A3] mb-8">Something went wrong. Please try again.</p>
            <Link to="/shop" className="inline-flex items-center gap-3 border border-white/20 text-[#F5F5F0] px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:border-[#C5A059] hover:text-[#C5A059] transition-colors" data-testid="try-again">
              Back to Shop <ArrowRight size={16} />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
